import { AfterViewInit, Directive, ElementRef, Input, OnChanges, SimpleChange, SimpleChanges } from "@angular/core";
import { NgOnChangesUtility } from "../functions";
import { StringUtility } from "../utils";

@Directive({
  selector: '[smataClientNgBtn]',
  standalone: true
})
export class ButtonDirective implements OnChanges, AfterViewInit {
  @Input() size = 'large';
  @Input() styleType = 'primary';
  @Input() fullWidth = 'fixed';

  private inputStyleApplied = false;

  constructor(private readonly el: ElementRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    const { size, styleType, fullWidth } = changes;
    this.applyStyle(size ?? new SimpleChange(undefined, this.size, false), this.getSizeClass);
    this.applyStyle(styleType ?? new SimpleChange(undefined, this.styleType, false), this.getStyleType);
    this.applyStyle(fullWidth ?? new SimpleChange(undefined, this.fullWidth, false), this.getFullWidth);
    this.inputStyleApplied = true;
  }

  ngAfterViewInit(): void {
    if (!this.inputStyleApplied) {
      this.ngOnChanges({});
    }
  }

  private applyStyle(styleChange: SimpleChange, getCssClass: (style: any) => string) {
    if (NgOnChangesUtility.hasChanges(styleChange)) {
      const { previousValue, currentValue } = styleChange;
      if (previousValue) {
        const previousClasses = getCssClass(previousValue).split(' ').filter(c => !StringUtility.isNullOrEmpty(c));
        if (previousClasses.length > 0) {
          this.el.nativeElement.classList.remove(...previousClasses);
        }
      }
      const currentClasses = getCssClass(currentValue).split(' ').filter(c => !StringUtility.isNullOrEmpty(c));
      if (currentClasses.length > 0) {
        this.el.nativeElement.classList.add(...currentClasses);
      }
    }
  }

  private getSizeClass(size: string) {
    let defaultClass = 'btn smata-ng-btn smata-font-normal';
    if (size === 'small') {
      return defaultClass += ' smata-font-12 smata-fixed-width-button-small pt-0 pb-0';
    }
    return defaultClass += ' smata-font-14 smata-fixed-width-button-large';
  }

  private getStyleType(styleType: string) {
    let defaultClass = 'smata-mat-btn-primary';

    switch(styleType) {
      case 'outline':
        defaultClass += ' smata-mat-btn-primary-outline';
        break;
      case 'danger':
        defaultClass += ' smata-mat-btn-danger-outline';
        break;
      case 'fillGray':
        defaultClass += ' smata-mat-btn-fill-gray';
        break;
      case 'outlineGray':
        defaultClass += ' smata-mat-btn-outline-gray';
        break;
    }

    return defaultClass;
  }

  private getFullWidth(fullWidth: string) {
    let defaultClass = '';

    /**
     * full width in media-breakpoint-down
     * @options 'xs', 'sm', 'md', 'lg', 'xl', 'xxl'
     */
    if (fullWidth !== 'fixed') {
      defaultClass += ` btn-full-width-${fullWidth}`
    }

    return defaultClass;
  }
}
